// File: firebaseConfig.js
//
// Connects this app to its Firebase project (the database, sign-in,
// etc.). Every page that needs to read/write data or check who's
// signed in imports from here.
//
// Heads up: the keys below LOOK like secrets but Firebase web keys
// are public by design — security is enforced by Firestore rules
// and the Auth provider settings in the Firebase console, NOT by
// hiding these values. Safe to commit to git.

import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";
import { initializeFirestore } from "firebase/firestore";

// The Firebase project this app talks to (project id: hopeioa).
// To point the app at a different Firebase project, swap these values
// out for the new project's web config (from the Firebase console).
const firebaseConfig = {
  apiKey: "AIzaSyB8i0N9dPApaDoUpRk__lqQTvLz6YdA-xo",
  authDomain: "hopeioa.firebaseapp.com",
  projectId: "hopeioa",
  storageBucket: "hopeioa.firebasestorage.app",
  messagingSenderId: "222175585983",
  appId: "1:222175585983:web:2158d75a789c5a2d9ec80a",
  measurementId: "G-88QYX7KXB4"
};

// Spin up Firebase and grab the pieces we use.
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);              // who's signed in
const provider = new GoogleAuthProvider(); // Google sign-in popup

// Auto-detect long polling: on some mobile/cellular networks the
// default Firestore transport gets blocked, which made inquiry
// submission fail on Android. This lets Firestore fall back to
// plain HTTP long polling automatically when needed.
const db = initializeFirestore(app, {
  experimentalAutoDetectLongPolling: true,
});

// Export everything so other files can import what they need.
export { auth, provider, db, signInWithPopup, signOut };
